import styled from 'styled-components';

const RadioBtnRow = styled.div`
  input {
    display: none;
    &:checked + label {
      background-color: ${p => p.theme.color.veryLightBlue};
      .indicator {
        border-color: ${p => p.theme.color.borderActive};
        &:after {
          display: block
        }
      }
    }
    &:disabled + label{
      pointer-events: none;
      opacity: .5;
    }
  }
  label {
    width: 100%;
    box-sizing: border-box;
    padding: 0.9em 1em;
    display: flex;
    align-items: center;
    cursor: pointer;
    p {
      margin: 0;
    }
    .sub-title {
      font-size: .9em;
      color: ${p => p.theme.color.label};
    }
    .info {
      flex: 1;
    }
  }
`;

const RadioBtnItem = styled.div`
  margin-right: 2em;
  padding-bottom: .3em;
  &:last-child {
    margin-right: 0;
  }
  .indicator {
    margin-left: 0;
  }
  input {
    display: none;
    &:checked + label .indicator {
        border-color: ${p => p.theme.color.borderActive};
        &:after {
          display: block;
        }
      }
    &:disabled + label {
      pointer-events: none;
      opacity: .5;
    }
  }
  label {     
    display: flex;
    align-items: center;
    cursor: pointer;
    .right-label {
      margin: 0 0 0 1em;
    }    
  } 
`;

const Indicator = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${p => p.theme.color.border};
  box-sizing: border-box;
  margin-left: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  &:after {
    display: none;
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${p => p.theme.color.borderActive};
  }
`;


export default {
  RadioBtnRow,
  RadioBtnItem,
  Indicator
};